import React from "react";
import ChangeList from "./ChangeList";

const ModuleChanges = ({ changes = [] }) => (
  <ChangeList changes={changes} title={"Modules"} fields={["permission"]} />
);

export default ModuleChanges;
